export interface ProjectCard {
  key: string;
  title: string;
  category: string;
  icon: string;
  description: string;
  status: string;
}

export const projectCategories: string[] = [
  "Passenger Mobility",
  "Commercial Mobility",
  "Cargo",
  "Fleet Electrification",
  "Special Applications",
];

export const projects: ProjectCard[] = [
  {
    key: "p1",
    title: "Passenger Mobility Retrofit",
    category: "Passenger Mobility",
    icon: "ri-car-line",
    description:
      "Retrofit applications for passenger vehicles used in everyday personal and shared mobility.",
    status: "Project details coming soon",
  },
  {
    key: "p2",
    title: "Commercial Mobility Retrofit",
    category: "Commercial Mobility",
    icon: "ri-truck-line",
    description:
      "Retrofit applications evaluated for commercial vehicles operating on defined routes.",
    status: "Project details coming soon",
  },
  {
    key: "p3",
    title: "Cargo Retrofit",
    category: "Cargo",
    icon: "ri-box-3-line",
    description:
      "Retrofit consideration for cargo vehicles where payload and duty cycle shape the configuration.",
    status: "Project details coming soon",
  },
  {
    key: "p4",
    title: "Fleet Electrification Programme",
    category: "Fleet Electrification",
    icon: "ri-roadster-line",
    description:
      "Phased fleet electrification planning combining vehicle assessment and charging considerations.",
    status: "Project details coming soon",
  },
  {
    key: "p5",
    title: "Special Applications",
    category: "Special Applications",
    icon: "ri-tools-line",
    description:
      "Application-specific retrofit studies for special-duty vehicles and unique use cases.",
    status: "Project details coming soon",
  },
];

export const projectGallery: ProjectCard[] = [
  ...projects,
  {
    key: "p6",
    title: "3-Wheeler Mobility Retrofit",
    category: "Passenger Mobility",
    icon: "ri-e-bike-2-line",
    description:
      "Retrofit applications for three-wheelers in high-utilisation local mobility duty cycles.",
    status: "Project details coming soon",
  },
];